import { autoserializeAs } from 'cerialize';
import { ConfigurationValue } from './configuration-value';

export class OperationalFootprintConfiguration {
  @autoserializeAs(ConfigurationValue)
  reputationWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  reliabilityWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  safetyWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  probabilityToChooseExperiencedDrivers: ConfigurationValue;
}
